const touchpoints = require('od-modules/xsell/config/touchpoints_names');
const appContext = require('od-modules/xsell/config/app_context');

const BOOKING_BRANDS = {
    ED: 'edr',
    OP: 'opo',
    GV: 'gvy',
    TL: 'tl',
};
const BOOKING_LABELS = {
    desktop: {
        [touchpoints.mytrips_hotels_banner]: 'mytrips_banner-pc-conf-of',
        [touchpoints.mytripsdetails_hotels_emerginglayer]: Odigeo.AB.isDesktopXsellEmlRedesign ? 'layer_logo-conf-pc-of' : 'layer_nologo-conf-pc-of',
        [touchpoints.sbextension_search_pc_of]: 'sbextension-search-pc-of',
        [touchpoints.mytripsdetails_hotels_itinerary_textlink]: 'mytrips_banner-pc-conf-of.itinerary',
    },
    mobile: {
        [touchpoints.confirmation_hotels_banner]: 'confscreen-conf-mob-of',
        [touchpoints.mytrips_hotels_banner]: Odigeo.AB.isHighlightFreeCancellation ? 'mytrips_banner-conf-mob-of-lup2119b'
            : 'mytrips_banner-conf-mob-of',
        [touchpoints.mytripsdetails_hotels_banner]: Odigeo.AB.isHighlightFreeCancellation ? 'homepagepostp-banner-mob-mytrips-lup2119b' :
            'homepagepostp-banner-mob-mytrips',
        [touchpoints.mytripsdetails_hotels_emerginglayer]: `confscreen-conf-mob-eml-${String.fromCharCode(Odigeo.AB.mobileXsellEmlRedesign + 96)}`,
        [touchpoints.mytripsdetails_hotels_floating_button]: 'floating_mb',
    },
};

const isPrimeEmlRevampDesktop = Odigeo.Membership.isHotelsForPrime && Odigeo.Membership.isPrimeEmlRevampDesktop;

const EXPEDIA_LABELS = {
    desktop: {
        [touchpoints.mytrips_hotels_banner]: 'banner_mb',
        [touchpoints.mytripsdetails_hotels_emerginglayer]: isPrimeEmlRevampDesktop ? 'layer_hot2088B' : 'layer_hot2088A',
        [touchpoints.mytripsdetails_hotels_widget]: 'hotel_widget',
        [touchpoints.mytripsdetails_hotels_itinerary_textlink]: 'banner_mb.itinerary',
    },
    mobile: {
        [touchpoints.confirmation_hotels_banner]: 'banner_cp',
        [touchpoints.mytrips_hotels_banner]: Odigeo.AB.isHighlightFreeCancellation ? 'banner_mb_lup2119b' : 'banner_mb',
        [touchpoints.mytripsdetails_hotels_banner]: Odigeo.AB.isHighlightFreeCancellation ? 'banner_mb_lup2119b' : 'banner_mb',
        [touchpoints.mytripsdetails_hotels_emerginglayer]: `layer_${String.fromCharCode(Odigeo.AB.mobileXsellEmlRedesign + 96)}`,
        [touchpoints.mytripsdetails_hotels_floating_button]: 'floating_mb',
        [touchpoints.mytripsdetails_hotels_widget_for_prime]: Odigeo.Membership.isHotelsConfirmationBenefitsWidget
            ? `banner_hot1392b` : `banner_hot1392a`,
    },
};

function getBookingLabelBrand() {
    return Odigeo._.get(BOOKING_BRANDS, appContext.getBrandId());
}

function getExpediaTracking(touchpoint = '', isPrime= false) {
    const CID = isPrime ? Odigeo.CrossSelling.expedia.expediaWab3IdPrime : Odigeo.CrossSelling.expedia.expediaWab3Id;
    const flowType = appContext.isDesktopFlow() ? 'site' : 'mobile';
    const touchPointTracking = EXPEDIA_LABELS[appContext.getFlow()][touchpoint] ?? touchpoint;
    return `|c.${CID}|l.${Odigeo.CrossSelling.locale}|t.${flowType}|s.${touchPointTracking}`;
}

function getBookingTracking(touchpoint = '') {
    const deeplinkLabel = BOOKING_LABELS[appContext.getFlow()][touchpoint] ?? touchpoint;
    return `${getBookingLabelBrand()}-link-${appContext.getTopLevelDomain()}-${deeplinkLabel}`;
}

function getBuyPath(touchpoint) {
    const buyPath = {
        [touchpoints.mytripsdetails_hotels_emerginglayer]: 'HSA_PB_EMERGINGLAYER',
        [touchpoints.mytrips_hotels_banner]: 'HSA_PB_BANNER',
        [touchpoints.mytripsdetails_hotels_banner]: 'HSA_PB_BANNER',
        [touchpoints.mytripsdetails_hotels_itinerary_textlink]: 'HSA_PB_ITINERARY',
        [touchpoints.supportarea_hotels_textlink]: 'HSA_MANAGEBOOKING',
    };
    return buyPath[touchpoint];
}

module.exports = {getExpediaTracking, getBookingTracking, getBuyPath};
